import { render, staticRenderFns } from "./ShipmentNomenclatureTable.vue?vue&type=template&id=0b28a3c8&scoped=true&"
import script from "./ShipmentNomenclatureTable.vue?vue&type=script&lang=js&"
export * from "./ShipmentNomenclatureTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentNomenclatureTable.vue?vue&type=style&index=0&id=0b28a3c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28a3c8",
  null
  
)

export default component.exports